import { render, staticRenderFns } from "./detail_card_list.vue?vue&type=template&id=1023e920&scoped=true"
import script from "./detail_card_list.vue?vue&type=script&lang=js"
export * from "./detail_card_list.vue?vue&type=script&lang=js"
import style0 from "./detail_card_list.vue?vue&type=style&index=0&id=1023e920&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023e920",
  null
  
)

export default component.exports